// Ecomm SKU constants - should match backend/ecomm/constants.py

// Evvy Test Shopify SKUs
export const VHT_TEST_SKU = "VMT001";
export const EXPANDED_TEST_SKU = "VMTEXP001";
export const EXPANDED_TEST_MEMBERSHIP_SKU = "EMEXP001";
export const STANDARD_TEST_MEMBERSHIP_SKU = "EM002";
export const STANDARD_TEST_MEMBERSHIP_SKU_GRANDFATHERED_PRICE = "EM001";
export const UTI_TEST_SKU = "UTI001";

// VHT and Expanded test SKUs (including memberships)
export const VHT_AND_EXPANDED_TEST_SKUS = new Set([
  VHT_TEST_SKU,
  EXPANDED_TEST_SKU,
  STANDARD_TEST_MEMBERSHIP_SKU,
  STANDARD_TEST_MEMBERSHIP_SKU_GRANDFATHERED_PRICE,
  EXPANDED_TEST_MEMBERSHIP_SKU,
]);
